import { endpoints } from "../../config/apiEndpoint";
import { apiClient } from "../shared/apiClient";

/**
 * add to cart
 *
 * @param {object} data and payment method id.
 * @return {Promise} A promise that resolves with products.
 */
export async function createOrder(data) {
  try {
    const response = await apiClient.post(
      endpoints.order.create,
      { ...data },
      true
    );
    return response;
  } catch (error) {
    console.error("Error order creation failed:", error);
    throw error;
  }
}

/**
 * fetch orders
 *
 * @return {Promise} A promise that resolves with Orders.
 */
export async function fetchAllOrders() {
  try {
    const response = await apiClient.get(endpoints.order.list, {}, true);
    return response;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
}

/**
 * fetch single order
 *
 * @param {string} orderId - The order ID.
 * @return {Promise} A promise that resolves with order details.
 */
export async function fetchOrder(orderId) {
  try {
    const response = await apiClient.get(
      `${endpoints.order.list}/${orderId}`,
      {},
      true
    );
    return response;
  } catch (error) {
    console.error(`Error fetching order ${orderId}:`, error);
    throw error;
  }
}

/**
 * cancel order
 *
 * @param {string} orderId - The order ID.
 * @return {Promise} A promise that resolves with cancellation status.
 */
export async function cancelOrder(orderId) {
  try {
    const response = await apiClient.delete(
      `${endpoints.order.base}/${orderId}`,
      {},
      true
    );
    return response;
  } catch (error) {
    console.error(`Error cancelling order ${orderId}:`, error);
    throw error;
  }
}
